import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #000000;
      color: white;
      background: none;
      border: none;
    }
    .dark-modal .modal-header {
      border : none
    }
    .dark-modal .close {
      color: white;
    }
  `]
})
export class LandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    if (isIEOrEdge) {
      $("#infoModal").modal('show');
    }
  }

  openWindowCustomClass(content) {
    //this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg'  });
  }

}
